import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import moment from 'moment';
import DataObject from './index.js';

var DateTime = /*#__PURE__*/function (_DataObject) {
  _inherits(DateTime, _DataObject);

  var _super = _createSuper(DateTime);

  function DateTime(props) {
    var _this;

    _classCallCheck(this, DateTime);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getMoment", function () {
      return _this.data;
    });

    _defineProperty(_assertThisInitialized(_this), "set", function (arg1, arg2) {
      _this.data = _this.data.set(arg1, arg2);
      return _assertThisInitialized(_this);
    });

    _defineProperty(_assertThisInitialized(_this), "add", function () {
      var _this$data;

      _this.data = (_this$data = _this.data).add.apply(_this$data, arguments);
      return _assertThisInitialized(_this);
    });

    _defineProperty(_assertThisInitialized(_this), "clone", function () {
      return _this.data.clone();
    });

    _defineProperty(_assertThisInitialized(_this), "subtract", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this.data = _this.data.subtract(args);
      return _assertThisInitialized(_this);
    });

    _defineProperty(_assertThisInitialized(_this), "getUtc", function () {
      _this.data = moment.utc(_this.data);
      return _assertThisInitialized(_this);
    });

    _defineProperty(_assertThisInitialized(_this), "getLongDate", function () {
      return _this.data.local().format('LL');
    });

    _defineProperty(_assertThisInitialized(_this), "getLongDateWithTime", function () {
      return _this.data.local().format('LLL');
    });

    _defineProperty(_assertThisInitialized(_this), "getDateStamp", function () {
      return _this.data.local().format('YYYY-MM-DD');
    });

    _defineProperty(_assertThisInitialized(_this), "getTimeStamp", function () {
      return _this.data.local().format('YYYY-MM-DD LTS');
    });

    _defineProperty(_assertThisInitialized(_this), "getHourStamp", function () {
      return _this.data.local().format('YYYY-MM-DD LT');
    });

    _defineProperty(_assertThisInitialized(_this), "getTimeStampHours", function () {
      return _this.data.local().format('YYYY-MM-DD LT');
    });

    _defineProperty(_assertThisInitialized(_this), "getTime", function () {
      return _this.data.local().format('LT');
    });

    _defineProperty(_assertThisInitialized(_this), "getShortDate", function () {
      var includeTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (includeTime) {
        return _this.data.local().format('D MMM - LT');
      }

      return _this.data.local().format('D MMM');
    });

    _defineProperty(_assertThisInitialized(_this), "getDay", function () {
      return _this.data.local().format('dddd');
    });

    _defineProperty(_assertThisInitialized(_this), "getDateString", function () {
      return _this.data.local().format('dddd D MMMM');
    });

    _defineProperty(_assertThisInitialized(_this), "getFromNow", function () {
      return _this.data.local().fromNow();
    });

    _defineProperty(_assertThisInitialized(_this), "format", function (format) {
      return _this.data.local().format(format);
    });

    _defineProperty(_assertThisInitialized(_this), "isSame", function (date) {
      return _this.data.isSame(date);
    });

    _defineProperty(_assertThisInitialized(_this), "getUTCTimeStamp", function () {
      return _this.data.format('YYYY-MM-DDTHH:mm:ss');
    });

    _defineProperty(_assertThisInitialized(_this), "endOf", function (period) {
      _this.data = _this.data.endOf(period);
      return _assertThisInitialized(_this);
    });

    var locale = localStorage.getItem('language');

    if (locale != null) {
      if (locale == 'sv') {
        locale = 'sv-se';
        localStorage.setItem("language", "sv-se");
      } else if (locale == 'en') {
        locale = 'en-us';
        localStorage.setItem("language", "en-us");
      } else if (locale == 'nb') {
        locale = 'nb-no';
        localStorage.setItem("language", "nb-no");
      } else if (locale == 'nn') {
        locale = 'nn-no';
        localStorage.setItem("language", "nn-no");
      }

      moment.locale(locale);
    }

    if (_this.data != null) {
      if (_this.data.constructor.name == 'DateTime') {
        _this.data = moment.utc(_this.data.getTimeStamp());
      } else {
        _this.data = moment.utc(_this.data);
      }
    } else {
      _this.data = moment.utc();
    }

    return _this;
  }

  return _createClass(DateTime);
}(DataObject);

export default DateTime;